import React from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { localise } from '../../../../services/lang/lang';
import PageHeader from '../../../modules/PageHeader';
import PageContent from '../../../modules/PageContent/PageContent';
import ActiveUsersWrapper from './ActiveUsersWrapper';
import MainLayoutSidebar from '../../../modules/MainLayout/MainLayoutSidebar';
import InvitedUsersWrapper from './InvitedUsersWrapper';
import useCanUserViewFeature from '../../../../hooks/useCanUserViewFeature';
const TeamManagement = () => {
    const { canView: userCanInvite } = useCanUserViewFeature([
        'service-provider.users-invite-create',
    ]);
    return (React.createElement(MainLayoutSidebar, { sidebarSection: "settings", selected: "settings" },
        React.createElement(Tabs, null,
            React.createElement(PageHeader, { title: localise('TEAM_MANAGEMENT') },
                React.createElement(TabList, null,
                    React.createElement(Tab, { "data-testid": "team_management__active_users_tab", tabIndex: 0 }, localise('ACTIVE')),
                    React.createElement(Tab, { "data-testid": "team_management__invited_users_tab", tabIndex: 0 }, localise('INVITED')))),
            React.createElement(PageContent, null,
                React.createElement(TabPanels, null,
                    React.createElement(TabPanel, null,
                        React.createElement(ActiveUsersWrapper, { canInvite: userCanInvite })),
                    React.createElement(TabPanel, null,
                        React.createElement(InvitedUsersWrapper, { canInvite: userCanInvite })))))));
};
export default TeamManagement;
